import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { ModalDataItem } from "./types";

const actionCreator = actionCreatorFactory("@@App");

export const appActions = {
  init: actionCreator.async<CommonAsyncType, {}>("INIT"),
  showLoading: actionCreator("SHOW_LOADING"),
  hideLoading: actionCreator("HIDE_LOADING"),
  showModal: actionCreator<ModalDataItem>("SHOW_MODAL"),
  hideModal: actionCreator("HIDE_MODAL"),
  showSessionExpiredModal: actionCreator("SHOW_SESSION_EXPIRED_MODAL"),
  hideSessionExpiredModal: actionCreator("HIDE_SESSION_EXPIRED_MODAL"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
